// React
import React from 'react';
// External
import { Form } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import SelectSearch from 'react-select-search';
import { BsChevronDown } from 'react-icons/bs';
// Styles
import './styles.scss';

/**
 * @param {Object} props.className - Class to be applied to the button
 * @param {Object} props.controlClassName - Class to be applied to the button
 * @param {Function} props.options - On click function handler
 */
class EngravingSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: this.props.hasError ? this.props.hasError : ''
        };
    }

    componentDidUpdate(prevProps) {
        // Only when the value changes the status update will be triggered
        if (prevProps.hasError !== this.props.hasError) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ hasError: this.props.hasError });
        }
    }

    onChange(value, obj) {
        this.setState({ hasError: false });
        this.props.onChange(value, obj);
    }

    defaultValue(value, obj) {
        this.setState({ hasError: false });
        this.props.defaultValue(value, obj);
    }

    render() {
        return (
            <div className="selector">
                <SelectSearch
                    className={this.props.className}
                    options={this.props.options ? this.props.options : []}
                    onChange={(value, obj) => { this.onChange(value, obj); }}
                    defaultValue={(value, obj) => { this.defaultValue(value, obj); }}
                    renderValue={(valueProps) => (
                        <Form.Control
                            {...valueProps}
                            className={this.state.hasError ? 'is-invalid' : ''}
                            name={this.props.name}
                            type="text"
                            value={this.props.value}
                            placeholder={this.props.placeholder}
                        />
                    )}
                />
                <BsChevronDown className={this.state.hasError ? 'is-invalid-padding' : ''} />
            </div>
        );
    }
}

export default withRouter(EngravingSelector);
